var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"responsive-modal-content"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"heading"},[_vm._t("heading")],2)]),_c('div',{staticClass:"body"},[_vm._t("body")],2),_c('div',{staticClass:"footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }